import { createAction, props } from '@ngrx/store';

export const datasetRefreshFromContextMenu = createAction(
  '[Report Editor Route] Dataset Refresh Button Clicked From Sidebar Context Menu',
  props<{ reportToken: string; switchViewToken: string }>()
);

export const datasetRefreshFromQueryNavContextMenu = createAction(
  '[Report Editor Route] Dataset Refresh Button Clicked From Query Nav Context Menu',
  props<{ reportToken: string; switchViewToken: string }>()
);

export const datasetRefreshFromDatasetTab = createAction(
  '[Report Editor Route] Dataset Refresh Tooltip Clicked From Dataset Tab',
  props<{ reportToken: string; switchViewToken: string }>()
);

export const datasetRefreshFromSideBar = createAction(
  '[Report Editor Route] Dataset Refresh Tooltip Clicked From Sidebar',
  props<{ reportToken: string; switchViewToken: string }>()
);
